var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-CN",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 213.52h896v596.96H64z",
    fill: "#E20012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M944 229.52v564.96H80V229.52h864m16-16H64v596.96h896V213.52z",
    fill: "#E20012"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M213.4 269.37l19.91 65.54 65.36-0.26-52.75 39.45 19.49 60.95-52.01-37.93-52.01 37.93 19.5-60.95-52.76-39.45 65.36 0.26zM421.3 392.81l7 20.61 20.76-0.76-16.35 13.08 6.83 19.15-16.91-11.51-16.13 12.59 5.56-19.56-17.17-11.98 20.77-0.6zM409.48 306.51l14.91 15.86 18.57-9.29-9.45 18.67 14.14 14.6-20.16-3.46-9.46 18.14-3.04-20.11-20.59-3.79 18.65-9.15zM374.47 246.03l-2.3 21.64 19.16 8.03-20.32 5-1.86 20.25-10.51-17.55-19.92 4.65 13.26-15.41-10.55-18.08 19.09 8.17zM374.36 454.63l-1.89 21.68 19.3 7.66-20.22 5.39-1.47 20.28-10.85-17.34-19.82 5.03 12.96-15.67-10.89-17.88 19.25 7.82z",
    fill: "#F6E202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/CN.1f1c1cd6404eeb72aab06bcf38115c17.svg";
export { ForwardRef as ReactComponent };